import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import LockUsersModal from "./modals/LockUsersModal";
import { getLockedUsers, updateLoginAttempts } from "../services/adminPanel_service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LockedUsersTab = () => {
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const [selectedUsersToUnlock, setSelectedUsersToUnlock] = useState([]);
  const [showLockModal, setShowLockModal] = useState(false);

  const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours ? hours : 12;

        return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
    };

  const fetchLockedUsers = async() => {
    try{
        const response = await getLockedUsers();
        setRowData(response.data);
    }
    catch{
        setRowData([])
    }
  }

  useEffect(()=>{
    fetchLockedUsers();
  },[])

  const handleLock = () => {
    setShowLockModal(true);
  };

  const handleUnlock = async() => {
    if(selectedUsersToUnlock.length === 0){
        toast.error('Select at least one user to unlock')
        return
    }
    try{
            for(var user of selectedUsersToUnlock){
                const payload = {
                "UserId": user.userId,
                "IsUser": user.roleId === 1?2:1,
                "LockedType": 3,
                "LockReason" : null
               }
               await updateLoginAttempts(payload)
            }
            toast.success('Selected users unlocked successfully')
            fetchLockedUsers();
        }
        catch{
            toast.success('Unable to unlock selected users')
        }
  };

  const handleBlockIP = () => {
    console.log("Redirect to Block/Unblock IP");
  };

  const handleGridSelectionChange = (params) => {
    const selected = params.api.getSelectedRows();
    setSelectedUsersToUnlock(selected);
  }

  const columnDefs = [
    { headerName: "User Name", field: "userName", filter: true },
    { headerName: "First Name", field: "firstName", filter: true },
    { headerName: "Last Name", field: "lastName", filter: true },
    { headerName: "Email", field: "emailAddress", filter: true },
    { headerName: "IP Address", field: "loginIp", filter: true },
    { headerName: "Lock Reason", field: "lockReason", filter: true },
    { headerName: "Last Login Attempt", field: "lastLoginDate", filter: true,valueFormatter: (params) => formatDateTime(params.value) },
    {
      headerName: "Select",
      field: "select",
      flex: 1,
      checkboxSelection: true
    }
  ];

  return (
    <>
      <div className="row" style={{ position: "relative", top: "10px" }}>
        <div className="text-right">
          <button
            className="btn btn-primary"
            onClick={handleLock}
          >
            Lock
          </button>

          <button
            className="btn btn-primary"
            style={{ marginLeft: "5px" }}
            onClick={handleUnlock}
          >
            UnLock
          </button>

          <button
            className="btn btn-primary"
            style={{ marginLeft: "5px" }}
            onClick={()=>navigate("/IPSettings")}
          >
            Block Or UnBlock IP
          </button>
        </div>
      </div>

      <div
        className="row generic-kendoGrid-custom admin-kendoGrid-custom"
        style={{ paddingLeft: "10px", position: "relative", top: "15px" }}
      >
        <div
          className="ag-theme-alpine"
          style={{ height: 500, width: "100%" }}
        >
          <AgGridReact
            theme={"legacy"}
            rowData={rowData}
            columnDefs={columnDefs}
            onSelectionChanged={handleGridSelectionChange}
            rowSelection="multiple"
            pagination={true}
          />
        </div>
      </div>

      {showLockModal && (
        <LockUsersModal
          show={showLockModal}
          onClose={() => setShowLockModal(false)}
          onDataReload={fetchLockedUsers}
        />
      )}
    </>
  );
};

export default LockedUsersTab;